module.exports = __webpack_public_path__ + "0775768a08e6c7b87a82d7fe9a57c1c3.png";